export default __webpack_public_path__ + "static/media/project.626af5cc.jpg";